import transformToDate from "../../transformToDate";
import {getLidarFileNames} from "../../getLidarFileNames";



export const milton_obj_arr_july_2025 = async (accessToken) =>  {
  try {
    const main_path = 'processed-lidar-data/milton_ga_processed/';
  
    const raw_lidar_paths = await getLidarFileNames(main_path, accessToken)
    const lidar_paths = raw_lidar_paths.data.map(item => item.replace(main_path, '').replace('/', ''));
  return lidar_paths.map((path) => {
      const match = path.match(/\d{8}/);
    let date = '';
if (match) {
  const dateStr = match[0]; // "11082025"

  const month = dateStr.slice(0, 2);
  const day = dateStr.slice(2, 4);
  const year = dateStr.slice(4, 8);

  const readableDate = `${month}/${Number(day)}/${year}`;
  date = readableDate;

}
  return {
    url: `${process.env.REACT_APP_LIDAR_CDN_URL}/milton_ga_processed/${path}`,
    name: `Milton GA - ${path}`,
    description: `Scan of processed Milton GA ${transformToDate(date)}`,
  date_uploaded: new Date(date),
  data_identifier: 'milton_ga',
  collector: 'NV5',
  projection: "+proj=tmerc +lat_0=30 +lon_0=-84.1666666666667 +k=0.9999 +x_0=699999.9998984 +y_0=0 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=us-ft +no_defs",
  }})
  } catch (error) {
    console.error('Error fetching Milton GA lidar paths:', error);
    return [];
  }
 
};


